import React from "react";
import Hero from "../components/Hero";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import {Container} from "reactstrap";

export const Home = () => {

    return (
        <>
            <NavBar/>
            <Container className="flex-grow-1 mt-5">
                <div className="home-page">
                    <Hero/>
                </div>
            </Container>
            <Footer/>
        </>
    );
};

export default Home;
